import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const CommentIcon = (props: any) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M19 5.4c.6 0 1 .4 1 1v12.2l-.9-.9c-.2-.2-.4-.3-.7-.3H5c-.6 0-1-.4-1-1v-10c0-.6.4-1 1-1h14m0-1H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h13.4l.9.9L21 21V6.4c0-1.1-.9-2-2-2z" />
      <path d="M6 13.9h12v1H6v-1zm0-6h12v1H6v-1zm0 3h12v1H6v-1z" />
    </SvgIcon>
  );
};

export default CommentIcon;
